import { Account } from './account';

export class Customer extends Account {}
